import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicFilterNoResults({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-7%"
          y="-15%"
          width="114.1%"
          height="142.1%"
          filterUnits="objectBoundingBox"
          id="pic-filter-no-results_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.04 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="M72.51 0c4.9 0 6.42.7 9.83 3.17 2.28 1.64 7.58 8.07 15.91 19.28 1.82 4.14 1.82 6.9 0 8.29-2.73 2.08-8.35 5.13-14.2-1.58-5.83-6.71-5.76-7.56-7.8-5.68-2.05 1.9-9 7.26-15.4 7.26-6.2 0-17.7-3.45-24.98-11.42A3171.6 3171.6 0 010 15.87L68.39 0v.42C69.62.14 71 0 72.52 0z"
          id="pic-filter-no-results_svg__b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M74.1 41.89C36.93 49.02 12 74.69 12 99.27c0 32.87 42.13 72.36 83.2 59.59 38.37-11.94 48.86-4.18 81.32-3.51C233 156.5 234.72 17.72 184.25 7.5 139.51-1.56 119.92 33.1 74.1 41.89z"
          fill="#E9EDFB"
        />
        <path
          d="M13.7 112.13c1.78-1.72 8.06-3.9 22.6 2.2 14.54 6.1 25.76 6.71 34.48 0 8.73-6.71 26.7-8 37 1.39 10.3 9.38 21.64 8.04 32.43 0s28.62-5.8 37.3 1.35c8.68 7.14 27.65 7.05 38.49-2.57-6.5 20.5-14 35-32.43 39.85-8.66 2.27-17.36.58-50.07-1.85-17.7-1.32-45.07 10.58-59.65 8.55-37.3-5.19-52.09-30.02-60.14-48.92z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <path
          d="M139.64 141.2c2.15-1.69 3.36-3.6 3.36-5.62 0-2.42-2.34-4.71-5.58-6.34M91.32 128c-5.02 1.28-8.14 4.33-9.32 7.58m4.66 7.9c5.66 3.5 14.92 5.52 25.5 5.52 3.43 0 6.73-.2 9.83-.6M104 142.33c2.58.43 5.46.67 8.5.67 11.32 0 20.5-3.36 20.5-7.5 0-4.14-9.18-7.5-20.5-7.5S92 131.36 92 135.5c0 1.58 1.33 3.04 3.6 4.25"
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <g transform="translate(102 75)">
          <path
            d="M28.35 24.34h-6.93c-.39-.05-.58.29-.58 1.02v34.43c-1.9 2.43-5.35 3.65-10.36 3.65S1.98 62.22 0 59.79V20.3C1.1 9.82 6.32 3.7 15.69 1.92h17.9l-5.24 22.42z"
            fill="#CCC"
          />
          <path
            d="M39.96 0v27.5h-8.64v-.03l-.27.03c-2.53 0-4.59-6.13-4.59-13.43S28.52 0 31.05 0c.1 0 .18 0 .27.03V0h8.64z"
            fill="#999"
          />
          <ellipse fill="#7EDEFF" cx={40.5} cy={13.8} rx={3.24} ry={11.88} />
          <ellipse stroke="#999" strokeWidth={1.62} cx={39.69} cy={13.8} rx={4.59} ry={12.96} />
          <ellipse stroke="#E8E8E8" strokeWidth={1.62} cx={41.31} cy={13.8} rx={4.59} ry={12.96} />
          <ellipse
            fill="#333532"
            transform="rotate(-7 40.84 8.89)"
            cx={40.84}
            cy={8.89}
            rx={1.62}
            ry={2.97}
          />
        </g>
        <g transform="translate(79 45)">
          <use
            fill="#000"
            filter="url(#pic-filter-no-results_svg__a)"
            xlinkHref="#pic-filter-no-results_svg__b"
          />
          <use fill="#FFF" xlinkHref="#pic-filter-no-results_svg__b" />
          <path
            d="M64.84 1.94C66.69.64 69.24 0 72.5 0c4.9 0 6.42.7 9.83 3.17 2.28 1.64 7.58 8.07 15.91 19.28 1.82 4.14 1.82 6.9 0 8.29-2.73 2.08-8.35 5.13-14.2-1.58-5.83-6.71-5.76-7.56-7.8-5.68-2.05 1.9-9 7.26-15.4 7.26S42.4 27.06 35.17 18.53c-4.81-5.7 5.08-11.22 29.67-16.6z"
            fill="#FFF"
          />
          <circle fill="#333532" cx={92.64} cy={27.96} r={1.62} />
          <path
            d="M89.07 29.58c-5.16 4.38-8.2 6.76-9.14 7.12.54-1.14 2.5-3.51 5.92-7.12h3.22z"
            fill="#FFE266"
          />
          <path fill="#FECE00" d="M79.93 36.7l9.02-4.23.87-3.27z" />
          <path
            d="M0 15.87L68.39 0c.25 7.73-1.72 13.02-5.9 15.87-6.28 4.27-13.26 4.11-17.35 4.11-2.73 0-17.78-1.37-45.14-4.11z"
            fill="#666"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicFilterNoResults.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicFilterNoResults.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicFilterNoResults svgRef={ref} {...props} />
));
export default ForwardRef;
